declare namespace $ {

	type $mol_select__Filter_shm_hitalama_map_widget_float_settings_chart_1 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__options_shm_hitalama_map_widget_float_settings_chart_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['table_head'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_settings_chart_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['axis'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_settings_chart_4 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_settings_chart_5 = $mol_type_enforce<
		({ 
			'day': string,
			'month': string,
			'year': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_settings_chart_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['axis_details'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_settings_chart_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_chart_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_chart_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['Axis_content'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_settings_chart_10 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__options_shm_hitalama_map_widget_float_settings_chart_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['table_head'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_settings_chart_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['values_title'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_chart_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_chart_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['Values'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select_list__value_shm_hitalama_map_widget_float_settings_chart_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['groups'] >
		,
		ReturnType< $mol_select_list['value'] >
	>
	type $mol_select_list__options_shm_hitalama_map_widget_float_settings_chart_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['table_head'] >
		,
		ReturnType< $mol_select_list['options'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_chart_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_chart_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_chart['Groups'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	export class $shm_hitalama_map_widget_float_settings_chart extends $shm_hitalama_map_widget_float_settings {
		table_head( ): readonly(any)[]
		axis( next?: string ): string
		Axis( ): $mol_select
		axis_details( next?: string ): string
		Axis_details( ): $mol_select
		axis_details_visible( ): readonly(any)[]
		Axis_content( ): $mol_view
		Axis_field( ): $mol_form_field
		values_title( next?: string ): string
		Values( ): $mol_select
		Values_field( ): $mol_form_field
		groups( next?: readonly(any)[] ): readonly(any)[]
		Groups( ): $mol_select_list
		Groups_field( ): $mol_form_field
		controls( ): readonly(any)[]
		controlled_settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=chart.view.tree.d.ts.map